import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import type { CustomRouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';
import type { InjectedFormProps } from 'redux-form';
import { reduxForm, Field } from 'redux-form';

import type * as UserFM from 'af-root/scenes/Authentication/formModel';
import validate from 'af-root/scenes/Authentication/PasswordForgotten/validations';

import { USER_PASSWORD_FORGOTTEN } from 'af-constants/reduxForms';
import CLIENT from 'af-constants/routes/client';

import { Button } from '@acceligentllc/storybook';

import Input from 'af-fields/Input';

import * as AuthenticationActions from 'af-actions/authentication';

type OwnProps = CustomRouteComponentProps;

type Props = OwnProps & ConnectedProps<typeof connector> & InjectedFormProps<UserFM.PasswordForgotten>;

class PasswordForgotten extends React.PureComponent<Props> {

	submitRequest = async (credentials: UserFM.PasswordForgotten) => {
		const { history, passwordForgotten, location: { state: { orgAlias } } } = this.props;
		credentials.orgAlias = orgAlias;
		await passwordForgotten(credentials);
		history.push(CLIENT.AUTH.PASS_FORGOTTEN_SUCCESS(orgAlias));
	};

	render(): React.JSX.Element {
		const { handleSubmit, submitting } = this.props;
		return (
			<div className="form-segment form-segment--mini">
				<div className="form-box form-box--standalone">
					<h2>Forgot your password?</h2>
					<h4>Enter your email address below, and we'll get you back on track.</h4>
					<div>
						<Row>
							<Col sm={24}>
								<Field
									component={Input}
									id="email"
									isRequired={true}
									label="Email"
									name="email"
									type="text"
								/>
							</Col>
						</Row>
						<Row className="row--padded">
							<Col sm={24}>
								<Button
									fullWidth={true}
									label="Submit"
									onClick={handleSubmit(this.submitRequest)}
									style="primary"
									submitting={submitting}
								/>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		);
	}
}

function mapDispatchToProps() {
	return {
		passwordForgotten: AuthenticationActions.passwordForgotten,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentClass<OwnProps>>(
	connector,
	reduxForm({ form: USER_PASSWORD_FORGOTTEN, validate })
);

export default enhance(PasswordForgotten);
